export const getEnumValues = (enumType: any) => {
    return Object.values(enumType).filter(value => typeof value === 'number') as typeof enumType[];
};